jQuery(function ($) {
  let altchaTest = null;

  function lockFocus(e) {
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    e.preventDefault();

    if (focusableElements.length === 1) {
      focusableElements[0].focus();
    } else {
      if (e.shiftKey) {
        focusableElementsCurrentIndex--;
        if (focusableElementsCurrentIndex < 0) {
          focusableElementsCurrentIndex = focusableElements.length - 1;
        }
      } else {
        focusableElementsCurrentIndex++;
        if (focusableElementsCurrentIndex >= focusableElements.length) {
          focusableElementsCurrentIndex = 0;
        }
      }

      $.each(focusableElements, function () {
        $(this).removeClass("force-focus");
      });

      $(focusableElements[focusableElementsCurrentIndex]).focus();

      // Check if the current focusable element is either an <a> or a <div>
      if ($(focusableElements[focusableElementsCurrentIndex]).is("a, div")) {
        $(focusableElements[focusableElementsCurrentIndex]).addClass(
          "force-focus"
        );
      }

      const focusableElement = $(".force-focus")[0];

      if (focusableElement) {
        focusableElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }

  //---- toggle FAQ ----------------------------------------------------------------
  // $(".faq-title").on("click", function () {
  //   $(this).next(".faq-body").slideToggle(500);
  //   $(this).find(".arrow-icon").toggleClass("collapsed");
  // });
  $(".close-toggle").on("click", function () {
    var termId = $(this).closest(".faq-middle").data("id");
    var termContent = $(".faq-content-" + termId);

    termContent.toggleClass("hidden");
    $(this).closest(".faq-middle").toggleClass("opened");
  });

  $(".faq-title").on("click", function () {
    var $faqTitle = $(this);
    var $faqBody = $faqTitle.next(".faq-body");
    var isExpanded = $faqBody.is(":visible");

    // Toggle the FAQ body visibility
    $faqBody.slideToggle(500);
    $(this).find(".arrow-icon").toggleClass("rotate-180");

    // Toggle the collapsed class and update aria-expanded attribute
    $faqTitle.find(".arrow-icon").toggleClass("collapsed", !isExpanded);
    $faqTitle.attr("aria-expanded", !isExpanded);

    // Update aria-hidden attribute for the corresponding FAQ body
    $faqBody.attr("aria-hidden", isExpanded);

    // If the FAQ body is now visible, scroll to the FAQ title
    if (!isExpanded) {
      var offset = $faqTitle.offset().top;
      $("html, body").animate({ scrollTop: offset }, 500);
    } else {
      var offset = $faqTitle.offset().top;
      $("html, body").animate({ scrollTop: offset }, 500);
    }
  });

  var logoColor = $(".logo-image svg path:nth-child(2)").attr("fill");

  $(".vector-mask.rec-vector .vector-color svg").attr("fill", logoColor);

  // Handle keyboard events for accessibility
  $(".close-toggle").on("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $(this).click();
    }
  });


  //---- Download File ----------------------------------------------------------------
  // $(".downloadButton").on("click", function () {
  //   var docu_link = $(this).data("docu");
  //   // Extract the filename from the URL and decode it
  //   var fileName = decodeURIComponent(
  //     docu_link.substring(docu_link.lastIndexOf("/") + 1)
  //   );

  //   // Create a temporary link element
  //   var downloadLink = document.createElement("a");
  //   downloadLink.href = docu_link;

  //   // Set the download attribute with the decoded filename
  //   downloadLink.download = fileName;

  //   // Append the link to the document
  //   document.body.appendChild(downloadLink);

  //   // Trigger a click on the link to start the download
  //   downloadLink.click();

  //   // Remove the link from the document
  //   document.body.removeChild(downloadLink);
  // });

  //---- Netwerk page pill half button -----------------------------------------------

  if (window.location.pathname === "/rotterdammers") {
    const mapView = document.getElementById("mapView");
    const listView = document.getElementById("listView");
    const divMap = document.getElementById("netwerk-map");

    mapView.addEventListener("click", function () {
      divMap.classList.add("show");

      mapView.classList.add("active");
      listView.classList.remove("active");

      mapView.setAttribute("aria-pressed", "true");
      listView.setAttribute("aria-pressed", "false");
    });

    listView.addEventListener("click", function () {
      divMap.classList.remove("show");

      listView.classList.add("active");
      mapView.classList.remove("active");

      listView.setAttribute("aria-pressed", "true");
      mapView.setAttribute("aria-pressed", "false");
    });

    if (localStorage.getItem("showMarkerModal") === "true") {
      // Toggle the modal visibility
      const modal = document.querySelector(".marker-modal");
      const closeModalButton = document.getElementById("closeModalButton");
      const modalName = document.getElementById("modal-name");
      const modalBody = document.getElementById("modal-body");
      const modalAddress = document.getElementById("modal-address");
      const modalWebsiteButton = document.getElementById(
        "modal-website-button"
      );

      if (modal) {
        const title = localStorage.getItem("modalDataName");
        const body = localStorage.getItem("modalDataBody");
        const add = localStorage.getItem("modalDataAdd");
        const colour = localStorage.getItem("modalDataColour");
        const url = localStorage.getItem("modalDataUrl");

        modalName.innerHTML = title;
        modalBody.innerHTML = body;
        modalAddress.innerHTML = add;
        modal.style.backgroundColor = colour;
        modalWebsiteButton.setAttribute("href", url);
        modalWebsiteButton.style.color = colour;

        modal.classList.toggle("hidden");

        closeModalButton.addEventListener("click", function () {
          modal.classList.add("hidden");
        });

        modalWebsiteButton.onclick = function () {
          window.open(url, "_blank");
        };
      }

      // Optionally clear the flag after the modal is shown
      localStorage.removeItem("showMarkerModal");
      localStorage.removeItem("modalDataName");
      localStorage.removeItem("modalDataBody");
      localStorage.removeItem("modalDataAdd");
      localStorage.removeItem("modalDataColour");
      localStorage.removeItem("modalDataUrl");
    }
  }

  //---- Copy Link -----------------------------------------------
  $(".clipboard").on("click", function () {
    var $temp = $("<input>");
    var $url = $(this).data("link"); // Retrieve the value of data-link attribute

    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();

    // Show the popup
    $("#popup").removeClass("hidden");

    // Hide the popup after a delay
    setTimeout(function () {
      $("#popup").addClass("hidden");
    }, 2000); // Adjust the delay as needed (in milliseconds)
  });

  //---- Netwerk page pill half button -----------------------------------------------

  if (window.location.pathname === "/contactpersonen") {
    const transitieView = $("#transitieView");
    const onderdeelView = $("#onderdeelView");
    const divTransitie = $("#transitiecontactpersonen-react-container");
    const divOnderdeel = $("#onderdeelcontactpersonen-react-container");

    onderdeelView.click(function () {
      divOnderdeel.show();
      divTransitie.hide();
      transitieView.removeClass("active");
      onderdeelView.addClass("active");
    });

    transitieView.click(function () {
      divTransitie.show();
      divOnderdeel.hide();
      onderdeelView.removeClass("active");
      transitieView.addClass("active");
    });
  }

  //---- Contact Form -----------------------------------------------
  if (document.getElementById("contactForm")) {
    const contactForm = document.getElementById("contactForm");
    const submitButton = document.getElementById("submitButton");

    submitButton.addEventListener("click", (event) => {
      // console.clear();
      
      event.preventDefault();

      // const loaderElement = document.querySelector(".loader");
      const loaderElement = document.getElementById("loader-form");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      // console.log("formData", formData);

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      // console.log("formValues", formValues);

      // TEST
      // if (altchaTest === null || altchaTest === undefined) {
      //   altchaTest = formValues.altcha;
      // } else {
      //   formValues.altcha = altchaTest;
      // }

      // console.log("Altcha value before AJAX request:", formValues.altcha);

      $.ajax({
        url: "/api/form/contact/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          document.getElementById("responseMessageName").innerHTML = "";
          document.getElementById("responseMessageEmail").innerHTML = "";
          document.getElementById("responseMessageMsg").innerHTML = "";
          document.getElementById("responseSuccess").innerHTML = "";
          document.getElementById("responseError").innerHTML = "";
          document.getElementById("responseMessageCheckbox").innerHTML = "";

          loaderElement.classList.remove("active");
          contactForm.reset();

          const modal = document.querySelector(".contact-success-modal");
          const closeButton = document.querySelector(
            ".contact-success-close"
          );

          function showDialog() {
            modal.classList.add("show-modal-contact");
            modal.classList.remove("invisible");
            modal.classList.remove("opacity-0");
            document.body.style.overflow = "hidden";

            $(".modal-content").attr("tabindex", "-1");

            focusableElements = [];
            focusableElements.push(closeButton);
            focusableElements.push($(".modal-content"));

            focusableElementsCurrentIndex = 0;
            $(document).on("keydown", lockFocus);
          }

          function closeDialog() {
            // modal.classList.remove("show-modal-contact");
            // modal.classList.add("invisible");
            // modal.classList.add("opacity-0");
            // document.body.style.overflow = "auto";

            // focusableElementsCurrentIndex = -1;
            // $(document).off("keydown", lockFocus);
            window.location.reload();
          }

          showDialog();

          // Add the event listener to the closeButton
          closeButton.addEventListener("click", closeDialog);
        },
        error: function (error) {
          // Parse the error response as JSON
          const errorResponse = JSON.parse(error.responseText);

          // console.log("errorResponse", errorResponse.errors);

          const errorKeys = Object.keys(errorResponse.errors);


          // Check if the only key is "terms"
          if (errorKeys.length === 1 && errorKeys[0] === "terms") {
            document.getElementById("responseSuccess").innerHTML = "";
          } else {
            const responseSuccessElement =
              document.getElementById("responseSuccess");

            responseSuccessElement.setAttribute("tabindex", "-1");
            responseSuccessElement.setAttribute("role", "alert");
            responseSuccessElement.classList.remove("force-focus");
          }

          // Display the error messages for each field
          if (errorResponse.errors.name) {
            console.log("error name");
            document.getElementById("responseMessageName").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.name[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageName").innerHTML = "";
          }

          if (errorResponse.errors.email) {
            document.getElementById("responseMessageEmail").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.email[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageEmail").innerHTML = "";
          }

          if (errorResponse.errors.message) {
            document.getElementById("responseMessageMsg").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.message[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageMsg").innerHTML = "";
          }

          if (errorResponse.errors.terms) {
            document.getElementById("responseMessageCheckbox").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.terms[0] +
              "</div>";
          } else {
            document.getElementById("responseMessageCheckbox").innerHTML = "";
          }

          if (errorResponse.errors.altcha) {
            document.getElementById("responseSuccess").innerHTML = errorResponse.errors.altcha[0];
          } else {
            document.getElementById("responseSuccess").innerHTML = "";
          }

          // General error message for the form submission
          if (errorResponse.errors.check) {
            document.getElementById("responseError").innerHTML = '<div class="error mt-4" tabindex="0">' +
              errorResponse.errors.check +
              "</div>";
          }

          setTimeout(function () {
            // Focus on the first error message
            let firstError = document.querySelector(".error");
            if (firstError) {
              firstError.focus();
              firstError.classList.add("force-focus");
              // console.log("Focusing on the first error:", firstError);
            } else {
              // console.log("No error to focus on");
            }
          }, 100); // Delay to allow DOM to update

          loaderElement.classList.remove("active");
        },
      });

      console.log(formValues);
    });
  }

  //---- Hidden Contact Form -----------------------------------------------
  if (document.getElementById("hiddenContactForm")) {
    const contactForm = document.getElementById("hiddenContactForm");
    const submitButton = document.getElementById("submitButton");

    $("#telefoonnummer")
      .on("input", function () {
        this.value = this.value.replace(/\D/g, "");
      })
      .on("keypress", function (e) {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      });

    submitButton.addEventListener("click", async (event) => {
      event.preventDefault();

      // const loaderElement = document.querySelector(".loader");
      const loaderElement = document.getElementById("loader-form");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      function readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      }

      for (const [key, value] of formData.entries()) {
        if (value instanceof File) {
          formValues[key] = await readFileAsBase64(value);
          formValues[`${key}_filename`] = value.name;
        } else {
          formValues[key] = value;
        }
      }

      // Step 1: Get CSRF token
      $.get('/session/token', function (csrfToken) {
        // Step 2: Make POST request with token in header
        $.ajax({
          url: "/api/form/hiddencontact/submit",
          type: "POST",
          contentType: "application/json",
          headers: {
            'X-CSRF-Token': csrfToken, // Include the token here
          },
          data: JSON.stringify(formValues),
          success: function (response) {
            console.log(response);
            document.getElementById("responseMessageName").innerHTML = "";
            document.getElementById("responseMessageEmail").innerHTML = "";
            document.getElementById("responseSuccess").innerHTML = "";
            document.getElementById("responseMessageCheckbox").innerHTML = "";

            loaderElement.classList.remove("active");
            contactForm.reset();

            const modal = document.querySelector(
              ".hidden-contact-success-modal"
            );
            const closeButton = document.querySelector(
              ".contact-success-close"
            );

            function showDialog() {
              modal.classList.add("show-modal-contact");
              modal.classList.remove("invisible");
              modal.classList.remove("opacity-0");
              document.body.style.overflow = "hidden";

              $(".modal-content").attr("tabindex", "-1");

              focusableElements = [];
              focusableElements.push(closeButton);
              focusableElements.push($(".modal-content"));

              focusableElementsCurrentIndex = 0;
              $(document).on("keydown", lockFocus);
            }

            function closeDialog() {
              modal.classList.remove("show-modal-contact");
              modal.classList.add("invisible");
              modal.classList.add("opacity-0");
              document.body.style.overflow = "auto";

              focusableElementsCurrentIndex = -1;
              $(document).off("keydown", lockFocus);
            }

            showDialog();

            // Add the event listener to the closeButton
            closeButton.addEventListener("click", closeDialog);
          },
          error: function (error) {
            console.error("error", error);

            // Parse the error response as JSON
            const errorResponse = JSON.parse(error.responseText);

            const responseSuccessElement =
              document.getElementById("responseSuccess");

            const errorKeys = Object.keys(errorResponse.errors);


            // Check if the only key is "terms"
            if (errorKeys.length === 1 && errorKeys[0] === "terms") {
              document.getElementById("responseSuccess").innerHTML = "";
            } else {
              const responseSuccessElement =
                document.getElementById("responseSuccess");

              responseSuccessElement.setAttribute("tabindex", "-1");
              responseSuccessElement.setAttribute("role", "alert");
              responseSuccessElement.classList.remove("force-focus");
            }

            // Display the error messages for each field
            if (errorResponse.errors.name) {
              document.getElementById("responseMessageName").innerHTML =
                '<div class="error" tabindex="0">' +
                errorResponse.errors.name[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error" tabindex="0">' +
                "Niet alle velden zijn juist ingevuld" +
                "</div>";
            } else {
              document.getElementById("responseMessageName").innerHTML = "";
            }

            if (errorResponse.errors.email) {
              document.getElementById("responseMessageEmail").innerHTML =
                '<div class="error" tabindex="0">' +
                errorResponse.errors.email[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error" tabindex="0">' +
                "Niet alle velden zijn juist ingevuld" +
                "</div>";
            } else {
              document.getElementById("responseMessageEmail").innerHTML = "";
            }

            if (errorResponse.errors.organisatie) {
              document.getElementById("responseMessageOrganisatie").innerHTML =
                '<div class="error" tabindex="0">' +
                errorResponse.errors.organisatie[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error" tabindex="0">' +
                "Niet alle velden zijn juist ingevuld" +
                "</div>";
            } else {
              document.getElementById("responseMessageOrganisatie").innerHTML =
                "";
            }

            if (errorResponse.errors.telefoonnummer) {
              document.getElementById("responseMessageTel").innerHTML =
                '<div class="error" tabindex="0">' +
                errorResponse.errors.telefoonnummer[0] +
                "</div>";
              document.getElementById("responseSuccess").innerHTML =
                '<div class="error" tabindex="0">' +
                "Niet alle velden zijn juist ingevuld" +
                "</div>";
            } else {
              document.getElementById("responseMessageTel").innerHTML = "";
            }

            if (errorResponse.errors.terms) {
              document.getElementById("responseMessageCheckbox").innerHTML =
                '<div class="error" tabindex="0">' +
                errorResponse.errors.terms[0] +
                "</div>";
            } else {
              document.getElementById("responseMessageCheckbox").innerHTML = "";
            }

            setTimeout(function () {
              // Focus on the first error message
              let firstError = document.querySelector(".error");
              if (firstError) {
                firstError.focus();
                firstError.classList.add("force-focus");
                console.log("Focusing on the first error:", firstError);
              } else {
                console.log("No error to focus on");
              }
            }, 100); // Delay to allow DOM to update

            loaderElement.classList.remove("active");
          },
        });
      });

      console.log(formValues);
    });
  }

  //---- Loket Form -----------------------------------------------
  if (document.getElementById("loketForm")) {
    const contactForm = document.getElementById("loketForm");
    const submitButton = document.getElementById("submitButton");

    submitButton.addEventListener("click", (event) => {
      event.preventDefault();

      // const loaderElement = document.querySelector(".loader");
      const loaderElement = document.getElementById("loader-form");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      $.ajax({
        url: "/api/form/loket/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          console.log(response);
          document.getElementById("responseMessageName").innerHTML = "";
          document.getElementById("responseMessageEmail").innerHTML = "";
          document.getElementById("responseMessageMsg").innerHTML = "";
          document.getElementById("responseSuccess").innerHTML = "";
          document.getElementById("responseMessageCheckbox").innerHTML = "";

          loaderElement.classList.remove("active");
          contactForm.reset();

          const modal = document.querySelector(".loket-success-modal");
          const closeButton = document.querySelector(".loket-success-close");

          function showDialog() {
            modal.classList.add("show-modal-loket");
            modal.classList.remove("invisible");
            modal.classList.remove("opacity-0");
            document.body.style.overflow = "hidden";

            $(".modal-content").attr("tabindex", "-1");

            focusableElements = [];
            focusableElements.push(closeButton);
            focusableElements.push($(".modal-content"));

            focusableElementsCurrentIndex = 0;
            $(document).on("keydown", lockFocus);
          }

          function closeDialog() {
            modal.classList.remove("show-modal-loket");
            modal.classList.add("invisible");
            modal.classList.add("opacity-0");
            document.body.style.overflow = "auto";

            focusableElementsCurrentIndex = -1;
            $(document).off("keydown", lockFocus);
          }

          showDialog();

          // Add the event listener to the closeButton
          closeButton.addEventListener("click", closeDialog);
        },
        error: function (error) {
          console.error(error);

          // Parse the error response as JSON
          const errorResponse = JSON.parse(error.responseText);

          const responseSuccessElement =
            document.getElementById("responseSuccess");

          const errorKeys = Object.keys(errorResponse.errors);

          // Check if the only key is "terms"
          if (errorKeys.length === 1 && errorKeys[0] === "terms") {
            document.getElementById("responseSuccess").innerHTML = "";
          } else {
            const responseSuccessElement =
              document.getElementById("responseSuccess");

            responseSuccessElement.setAttribute("tabindex", "-1");
            responseSuccessElement.setAttribute("role", "alert");
            responseSuccessElement.classList.remove("force-focus");
          }

          // Display the error messages for each field
          if (errorResponse.errors.name) {
            document.getElementById("responseMessageName").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.name[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageName").innerHTML = "";
          }

          if (errorResponse.errors.email) {
            document.getElementById("responseMessageEmail").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.email[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageEmail").innerHTML = "";
          }

          if (errorResponse.errors.message) {
            document.getElementById("responseMessageMsg").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.message[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseMessageMsg").innerHTML = "";
          }

          if (errorResponse.errors.terms) {
            document.getElementById("responseMessageCheckbox").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.terms[0] +
              "</div>";
          } else {
            document.getElementById("responseMessageCheckbox").innerHTML = "";
          }

          setTimeout(function () {
            // Focus on the first error message
            let firstError = document.querySelector(".error");
            if (firstError) {
              firstError.focus();
              firstError.classList.add("force-focus");
              console.log("Focusing on the first error:", firstError);
            } else {
              console.log("No error to focus on");
            }
          }, 100); // Delay to allow DOM to update

          loaderElement.classList.remove("active");
        },
      });


      console.log(formValues);
    });
  }

  //---- Deher Form -----------------------------------------------
  if (document.getElementById("deherForm")) {
    const contactForm = document.getElementById("deherForm");
    const submitButton = document.getElementById("submitButton");

    submitButton.addEventListener("click", (event) => {
      event.preventDefault();

      // const loaderElement = document.querySelector(".loader");
      const loaderElement = document.getElementById("loader-form");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      // TEST
      // if (altchaTest === null || altchaTest === undefined) {
      //   altchaTest = formValues.altcha;
      // } else {
      //   formValues.altcha = altchaTest;
      // }

      // console.log("Altcha value before AJAX request (deher):", formValues.altcha);
      // return;

      $.ajax({
        url: "/api/form/deher/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          console.log(response);
          document.getElementById("responseDeherName").innerHTML = "";
          document.getElementById("responseDeherEmail").innerHTML = "";
          document.getElementById("responseDeherMsg").innerHTML = "";
          document.getElementById("responseSuccess").innerHTML = "";
          document.getElementById("responseError").innerHTML = "";
          document.getElementById("responseMessageCheckbox").innerHTML = "";

          loaderElement.classList.remove("active");
          contactForm.reset();

          const modal = document.querySelector(".deher-success-modal");
          const closeButton = document.querySelector(".deher-success-close");

          function showDialog() {
            modal.classList.add("show-modal-deher");
            modal.classList.remove("invisible");
            modal.classList.remove("opacity-0");
            document.body.style.overflow = "hidden";

            $(".modal-content").attr("tabindex", "-1");

            focusableElements = [];
            focusableElements.push(closeButton);
            focusableElements.push($(".modal-content"));

            focusableElementsCurrentIndex = 0;
            $(document).on("keydown", lockFocus);
          }

          function closeDialog() {
            // modal.classList.remove("show-modal-deher");
            // modal.classList.add("invisible");
            // modal.classList.add("opacity-0");
            // document.body.style.overflow = "auto";

            // focusableElementsCurrentIndex = -1;
            // $(document).off("keydown", lockFocus);

            window.location.reload();
          }

          showDialog();

          // Add the event listener to the closeButton
          closeButton.addEventListener("click", closeDialog);
        },
        error: function (error) {
          console.error(error);

          // Parse the error response as JSON
          const errorResponse = JSON.parse(error.responseText);

          const responseSuccessElement =
            document.getElementById("responseSuccess");
          const errorKeys = Object.keys(errorResponse.errors);


          // Check if the only key is "terms"
          if (errorKeys.length === 1 && errorKeys[0] === "terms") {
            document.getElementById("responseSuccess").innerHTML = "";
          } else {
            const responseSuccessElement =
              document.getElementById("responseSuccess");

            responseSuccessElement.setAttribute("tabindex", "-1");
            responseSuccessElement.setAttribute("role", "alert");
            responseSuccessElement.classList.remove("force-focus");
          }


          // Display the error messages for each field
          if (errorResponse.errors.naam) {
            document.getElementById("responseDeherName").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.naam[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseDeherName").innerHTML = "";
          }

          if (errorResponse.errors.email_adres) {
            document.getElementById("responseDeherEmail").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.email_adres[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseDeherEmail").innerHTML = "";
          }

          if (errorResponse.errors.uw_vraag) {
            document.getElementById("responseDeherMsg").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.uw_vraag[0] +
              "</div>";
            responseSuccessElement.innerHTML =
              '<div class="error" tabindex="0">' +
              "Niet alle velden zijn juist ingevuld" +
              "</div>";
          } else {
            document.getElementById("responseDeherMsg").innerHTML = "";
          }


          if (errorResponse.errors.terms) {
            document.getElementById("responseMessageCheckbox").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.terms[0] +
              "</div>";
          } else {
            document.getElementById("responseMessageCheckbox").innerHTML = "";
          }

          if (errorResponse.errors.altcha) {
            document.getElementById("responseError").innerHTML = '<div class="error mt-4" tabindex="0">' +
              errorResponse.errors.altcha[0] +
              "</div>";
          }

          // General error message for the form submission
          if (errorResponse.errors.check) {
            document.getElementById("responseError").innerHTML = '<div class="error mt-4" tabindex="0">' +
              errorResponse.errors.check +
              "</div>";
          }

          setTimeout(function () {
            // Focus on the first error message
            let firstError = document.querySelector(".error");
            if (firstError) {
              firstError.focus();
              firstError.classList.add("force-focus");
              console.log("Focusing on the first error:", firstError);
            } else {
              console.log("No error to focus on");
            }
          }, 100); // Delay to allow DOM to update

          loaderElement.classList.remove("active");
        },
      });


      console.log(formValues);
    });
  }

  function setImagePadding() {
    // Get the height of the image
    var imageHeight = $(".absolute-image").outerHeight();
    // Set the padding-top for the next container
    var newHeight = imageHeight / 2;
    if ($(window).width() <= 768) {
      newHeight = imageHeight;
    } else if ($(window).width() >= 1536) {
      newHeight = imageHeight / 1.5;
    }
    $(".absolute-content").css("padding-top", newHeight + "px");
  }

  // // Check initial window width for padding
  // if ($(window).width() <= 768) {
  //   // Wait until the image is fully loaded
  //   $(".absolute-image").on("load", function () {
  //     setImagePadding();
  //   });
  // }

  // // Check if the image is already cached and set the initial padding
  // $(".absolute-image").each(function () {
  //   if (this.complete) {
  //     $(this).trigger("load");
  //   }
  // });

  $(document).ready(function () {
    setImagePadding();
    const $originalSection = $(".flexible-sec-669");

    if ($originalSection.length && window.location.pathname === "/de-her") {
      const width = window.innerWidth;

      $originalSection.find(".link-btn").attr("target", "_blank");

      if (width < 768) {
        // Insert into mobile position immediately
        $originalSection.insertAfter(".tiles:first");
        window.flexInsertedMobile = true;
      } else {
        // Detach and store, then prepend to desktop container
        window.originalFlexSection = $originalSection.detach();
        $(".deHer-flexi-wrapper").first().prepend(window.originalFlexSection);
        window.flexInsertedMobile = false;
      }

      // Apply initial padding rules
      updateResponsivePadding(width);
    }

    // On resize
    $(window).on("resize", function () {
      const width = window.innerWidth;
      updateResponsivePadding(width);
      moveFestivalBlock(width);
      setImagePadding();
    });
  });

  function updateResponsivePadding(width) {
    if (width <= 768) {
      setImagePadding();
    } else if (width < 1312) {
      $(".absolute-content").css("padding-top", "14rem");
    } else {
      $(".absolute-content").css("padding-top", "18rem");
    }
  }

  function moveFestivalBlock(width) {
    if (window.location.pathname !== "/de-her") return;

    if (width < 768) {
      // Mobile: Insert after tiles
      if (!window.flexInsertedMobile && window.originalFlexSection) {
        window.originalFlexSection.insertAfter(".tiles:first");
        window.flexInsertedMobile = true;
      }
    } else {
      // Desktop: Move to desktop wrapper
      const $section = $(".flexible-sec-669");

      if (window.flexInsertedMobile && $section.length) {
        window.originalFlexSection = $section.detach();
        $(".deHer-flexi-wrapper").first().prepend(window.originalFlexSection);
        window.flexInsertedMobile = false;
      }
    }
  }

  //---- counter date -----------------------------------------------
  const $wrapper = $(".timeline-wrapper");
  const launchDateStr = $wrapper.data("date-time");
  const $day = $(".timeline-wrapper .date");
  const $time = $(".timeline-wrapper .time");

  if (launchDateStr && $day.length && $time.length) {
    const launchDate = new Date(launchDateStr);

    function updateCountdown() {
      const now = new Date();
      const diff = launchDate - now;

      if (diff <= 0) {
        $day.text("0");
        $time.text("00 : 00 : 00");
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      $day.text(days);
      $time.text(
        `${String(hours).padStart(2, "0")} : ${String(minutes).padStart(
          2,
          "0"
        )} : ${String(seconds).padStart(2, "0")}`
      );
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }


  /// ----- WEGWEIJER THEME HOVER ------
  var $modal = $('#tag-modal');
  var $content = $('#tag-modal-content');

  $('.tag-hover').on('mouseenter', function () {
    var desc = $(this).data('desc');
    var colour = $(this).data('colour');

    // If desc is empty, don't show the modal
    if (!desc || desc.trim() === '') {
      $modal.hide();
      $content.empty();
      return;
    }

    $content.html(desc);
    $modal.css('border-color', colour);

    var screenWidth = $(window).width();
    var modalRight = (screenWidth <= 1023) ? 20 : -280;

    $modal.css({
      right: modalRight + 'px',
      top: 0,
      transform: 'none'
    }).show();

  }).on('mouseleave', function () {
    $modal.hide();
    $content.empty();
  });

}); ////js
